import type { SizeType, ToneType, VariantType } from './types';

export type BadgeVariantType = VariantType;
export type BadgeSizeType = SizeType;

export const badgeSizeStyles: Record<BadgeSizeType, string> = {
  small: 'h-5 gap-1 px-2 text-[11px]',
  medium: 'h-6 gap-1.5 px-2.5 text-xs',
  large: 'h-7 gap-2 px-3 text-sm',
};

export const badgeToneStyles: Record<BadgeVariantType, Record<ToneType, string>> = {
  subtle: {
    primary: 'border-primary/30 bg-primary/10 text-primary',
    secondary: 'border-secondary/50 bg-secondary text-secondary-foreground',
    success: 'border-emerald-300 bg-emerald-50 text-emerald-700',
    destructive: 'border-rose-300 bg-rose-50 text-rose-700',
    warning: 'border-amber-300 bg-amber-50 text-amber-700',
    accent: 'border-fuchsia-300 bg-fuchsia-50 text-fuchsia-700',
    info: 'border-sky-300 bg-sky-50 text-sky-700',
    neutral: 'border-border bg-muted text-muted-foreground',
  },
  solid: {
    primary: 'border-primary bg-primary text-primary-foreground',
    secondary: 'border-secondary bg-secondary text-secondary-foreground',
    success: 'border-emerald-700 bg-emerald-700 text-white',
    destructive: 'border-rose-700 bg-rose-700 text-white',
    warning: 'border-amber-600 bg-amber-600 text-white',
    accent: 'border-fuchsia-700 bg-fuchsia-700 text-white',
    info: 'border-sky-700 bg-sky-700 text-white',
    neutral: 'border-zinc-700 bg-zinc-700 text-white',
  },
  outline: {
    primary: 'border-primary/40 bg-transparent text-primary',
    secondary: 'border-secondary/60 bg-transparent text-secondary-foreground',
    success: 'border-emerald-400 bg-transparent text-emerald-700',
    destructive: 'border-rose-400 bg-transparent text-rose-700',
    warning: 'border-amber-400 bg-transparent text-amber-700',
    accent: 'border-fuchsia-400 bg-transparent text-fuchsia-700',
    info: 'border-sky-400 bg-transparent text-sky-700',
    neutral: 'border-border bg-transparent text-foreground/80',
  },
  ghost: {
    primary: 'border-transparent bg-primary/5 text-primary',
    secondary: 'border-transparent bg-secondary/40 text-secondary-foreground',
    success: 'border-transparent bg-emerald-50/70 text-emerald-700',
    destructive: 'border-transparent bg-rose-50/70 text-rose-700',
    warning: 'border-transparent bg-amber-50/70 text-amber-700',
    accent: 'border-transparent bg-fuchsia-50/70 text-fuchsia-700',
    info: 'border-transparent bg-sky-50/70 text-sky-700',
    neutral: 'border-transparent bg-muted/50 text-muted-foreground',
  },
  link: {
    primary: 'border-transparent bg-transparent text-primary underline underline-offset-2',
    secondary:
      'border-transparent bg-transparent text-secondary-foreground underline underline-offset-2',
    success: 'border-transparent bg-transparent text-emerald-700 underline underline-offset-2',
    destructive: 'border-transparent bg-transparent text-rose-700 underline underline-offset-2',
    warning: 'border-transparent bg-transparent text-amber-700 underline underline-offset-2',
    accent: 'border-transparent bg-transparent text-fuchsia-700 underline underline-offset-2',
    info: 'border-transparent bg-transparent text-sky-700 underline underline-offset-2',
    neutral: 'border-transparent bg-transparent text-muted-foreground underline underline-offset-2',
  },
};
